var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c15e2cd0\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./PasswordResetConfirm.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-common/components/PasswordResetConfirm.vue
// module id = 381
// module chunks = 1